export const TEST_ID = 'withPencilIcon';
